import { UserConsentModalProps } from './types';
import { UserConsentContent } from './user-consent-content';
import { UserConsentModalWrapper } from './user-consent-modal-wrapper';

export const UserConsentModal = (props: UserConsentModalProps) => (
  <UserConsentModalWrapper>
    <UserConsentContent {...props} />
  </UserConsentModalWrapper>
);
